import React, { createContext } from "react";
import {apollo_useStyles } from "../atom/Apollo_styles";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";

type State = {
  open: boolean;
}
//初期データ
const initialState: State = {
  open: false,
}

export const ApolloRightDrawerContext = createContext({} as {
  drawerState: State
  setDrawerState: React.Dispatch<Action>
});

type Action = {
  type: string;
  payload: State;
}

// @ts-ignore
const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'open':
      return {
        ...state,
        open: true,
      }
    case 'close':
      return {
        ...state,
        open: false,
      }
    case 'toggle':
      return {
        ...state,
        open: !state.open,
      }
    default:
      return state;
  }
};

export const ApolloRightDrawerProvider: React.FC = ({ ...props }) => {

  const [drawerState, setDrawerState] = React.useReducer(reducer, initialState);
  return (
    <ApolloRightDrawerContext.Provider
      value={{
        drawerState,
        setDrawerState,
      }}
    >
      {props.children}
    </ApolloRightDrawerContext.Provider>
  );
};

export const RightDrawer: React.FC = ({...props}) => {
  const classes = apollo_useStyles();
  const { drawerState, setDrawerState } = React.useContext(ApolloRightDrawerContext)

  const toggleDrawer = (open: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent,
  ) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    
    if (open) {
      setDrawerState({
        type: 'open',
        payload: {
          ...drawerState,
          open: true,
        }
      });
    } else {
      setDrawerState({
        type: 'close',
        payload: {
          ...drawerState,
          open: false,
        }
      });
    }
    
    
  };

  return (
    <Drawer
      anchor={"right"}
      open={drawerState.open}
      onClose={toggleDrawer(false)}
      classes={{
        paper: clsx(classes.rightDrawer)
      }}
    >
      {props.children}
    </Drawer>
  );
};

